var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"share_btn",on:{"click":function($event){return _vm.runShare()}}},[_c('button',{staticClass:"kakao"}),_c('div',[_vm._v(_vm._s(_vm.$t('kakako')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }